exports = module.exports = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._2hur5ycOJDtkAV3_79UAtJ {\n  font-size: 18px;\n  font-weight: 600;\n  margin: 0 0 8px;\n  color: var(--primary-text-color);\n}\n\n.qTWYJVma3avu_PrRrHoS1 {\n  font-size: 14px;\n  color: var(--secondary-text-color);\n  margin: 0;\n}\n\n._2i7iyGsinelBiaNXO4On29 {\n  display: flex;\n  gap: 12px;\n  width: 100%;\n}\n", ""]);

// Exports
exports.locals = {
	"title": "_2hur5ycOJDtkAV3_79UAtJ",
	"body": "qTWYJVma3avu_PrRrHoS1",
	"buttonRow": "_2i7iyGsinelBiaNXO4On29"
};